import React, {Component} from 'react';
import Main from "../Controllers/Main";
import Breadcrumbs from "../../ui/template/Breadcrumbs/Breadcrumbs";
import { MCbrowser } from '../Context/browserContext';

class MainContent extends Component{

    constructor(props) {
        super(props);
        this.contentMain=React.createRef();
        this.props=props;
        this.pageBreadcrumbs=React.createRef();

    }

    componentDidMount() {
    }



    render() { 
        this.context.page.pageBreadcrumbs=this.pageBreadcrumbs;
        return (
            <React.Fragment>
                <div className="py-4">
                    <div className="container">
                        <div className="d-none">
                        <Breadcrumbs ref={this.pageBreadcrumbs} />
                        </div>
                        <Main />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    componentWillUnmount() {

    }
} 
MainContent.contextType = MCbrowser;
export default MainContent;